import type { SVGProps } from 'react';
const SvgRv = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.79 6.7c-.618 0-1.117.506-1.117 1.133v7.934c0 .627.499 1.133 1.116 1.133h1.004a3.34 3.34 0 0 1 2.9-1.7c1.242 0 2.323.684 2.901 1.7h8.814v-6.233c0-2.193-1.747-3.967-3.905-3.967zm.557 11.9h-.558C3.25 18.6 2 17.332 2 15.767V7.833C2 6.268 3.248 5 4.79 5h11.713c3.082 0 5.578 2.536 5.578 5.667V16.9h1.395c.463 0 .837.379.837.85s-.373.85-.837.85H12.04c0 1.877-1.5 3.4-3.347 3.4-1.848 0-3.347-1.523-3.347-3.4m0-9.067c0-.627.498-1.133 1.116-1.133h4.462c.617 0 1.116.506 1.116 1.133V11.8c0 .627-.499 1.133-1.116 1.133H6.463A1.123 1.123 0 0 1 5.347 11.8zM14.272 8.4h2.231c.617 0 1.116.506 1.116 1.133V11.8c0 .627-.499 1.133-1.116 1.133h-2.231a1.123 1.123 0 0 1-1.116-1.133V9.533c0-.627.499-1.133 1.116-1.133m-3.905 10.2c0-.939-.749-1.7-1.673-1.7s-1.674.761-1.674 1.7.75 1.7 1.674 1.7 1.673-.761 1.673-1.7"
    />
  </svg>
);
export default SvgRv;
